import { Operation } from '../../../__generated__/globalTypes'

import getBannersString from '../GetBanners.graphql'

export type GetBannersData = {
  banners: {
    id: string
    title: string
    htmlContent: string
    createdAt: string
    updatedAt: string
  }[]
}

export type GetBanners = Operation<GetBannersData>

export const GetBanners = (): GetBanners => ({
  query: getBannersString,
  variables: undefined,
})
